import { CodeBase} from "./_codeBase";

/**
 * 権限区分
 */
export class AuthDiv extends CodeBase<AuthDiv>
{
    /** 権限区分 "01", "システム管理者" */
    public static readonly SYS_ADMIN: AuthDiv = new AuthDiv("01", "システム管理者");
    /** 権限区分 "02", "プロジェクト管理者" */
    public static readonly PRJ_ADMIN: AuthDiv = new AuthDiv("02", "プロジェクト管理者");
    /** 権限区分 "03", "プロジェクトサブ管理者" */
    public static readonly SUB_ADMIN: AuthDiv = new AuthDiv("03", "プロジェクトサブ管理者");
    /** 権限区分 "04", "現場運用担当者" */
    public static readonly OPERATOR: AuthDiv = new AuthDiv("04", "現場運用担当者");
    /** 権限区分 "05", "現場作業者" */
    public static readonly WORKER: AuthDiv = new AuthDiv("05", "現場作業者");
    /** 権限区分 "06", "顧客" */
    public static readonly CUSTOMER: AuthDiv = new AuthDiv("06", "顧客");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): AuthDiv[] {
        return [
            AuthDiv.SYS_ADMIN,
            AuthDiv.PRJ_ADMIN,
            AuthDiv.SUB_ADMIN,
            AuthDiv.OPERATOR,
            AuthDiv.WORKER,
            AuthDiv.CUSTOMER
        ];
    }
}
